


































































import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import draggable from 'vuedraggable';

@Component({
  components: { draggable },
})

export default class DraggableDataTable extends Vue {
  @Prop({ required: true }) headerDefault!: any[];

  @Prop({ required: true }) items!: any[];

  @Prop({ default: 1 }) page!: number;

  @Prop({ default: () => [] }) sortBy!: any[];

  @Prop({ default: () => [] }) sortDesc!: any[];

  @Prop({ default: 10 }) itemsPerPage!: number;

  @Prop({ default: 1 }) pageCount!: number;

  @Prop({ default: false }) loading!: boolean;

  @Prop({ default: () => [] }) customSort!: Function;

  @Prop({ default: null, type: [Object, Function] }) readonly rowComponent!: any;

  @Prop({ default: '' }) readonly rowComponentRemove!: string;

  @Prop({ default: '' }) readonly businessUnitId!: string;

  @Prop({ required: true }) isAdministrator!: boolean;

  headers: any[] = this.headerDefault;

  created() {
    this.headers = this.headerDefault;
  }

  getClasses(header: any) {
    return header.draggable === false ? '' : 'itemHeader';
  }

  clickedOrdered(header: any, options: any) {
    const orderType = (options.sortBy[0] === header.value)
      ? !options.sortDesc[0]
      : false;

    const orderby = { sortBy: header.value, sortDesc: orderType };
    this.$emit('update:updateSortBy', orderby);
  }

  getStyles(header: any): string {
    let styles = 'cursor:pointer;';
    styles += header.align ? `text-align:${header.align};` : '';
    styles += header.width ? `min-width:${header.width};` : '';
    return styles;
  }

  onHeaderDragEnd(evt: any) {
    const newOrder = (evt?.item?.parentElement || evt?.to)?.children;
    if (!newOrder) return;
    const newHeaderTexts = Array.from(newOrder).map((el: any) => el);
    const reorder: any[] = [];
    newHeaderTexts.forEach((obj: any) => {
      const found = this.headerDefault.find((h: any) => h.text === obj.innerText.trim());
      if (found) reorder.push(found);
    });
    this.headers = [...reorder];
    this.$emit('update:saveHeaders', reorder.map((h) => h.value));
  }
}
